import { Component } from 'react';
import styles from './timer.css';
import React from 'react';
import { connect } from 'react-redux';
import { setTimerValue } from 'data/player/calendar/action';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {
    return {
        settings: state.calendar.settings
    };
};

const mapDispatchToProps = dispatch => ( {
    calendarPlayerActions: bindActionCreators( {
        setTimerValue
    }, dispatch )
} );

@connect( mapStateToProps, mapDispatchToProps )
class Timer extends Component {

    constructor( props ) {
        super( props );

        this.state = {
            printTimer: '',
            timerMode: 0,
            timerLimit: 120,
            sec: 0,
            min: 2,
            timerProgress: 0
        };

        this.interval = null;
    };

    setTimeLimit = () => {
        const { time_limit } = this.props.settings;
        let sec = 0;
        let tmode = 0;
        let min = ( Number( time_limit ) / 60 ).toFixed( 2 );
        if ( time_limit < 60 ) {
            sec = time_limit;
            tmode = 0;
        } else {
            let fractional = time_limit % 60;
            sec = Number( fractional );
            tmode = 1;
        }
        this.setState( { timerLimit: time_limit, timerMode: tmode, min: min, sec: sec, printTimer: '' } );
    };

    componentDidUpdate( prevProps ) {
        if ( JSON.stringify(this.props.statisticsPopup) !== JSON.stringify(prevProps.statisticsPopup) ) {
            this.setTimeLimit();
            clearInterval( this.interval );
        }
    }

    setTimer = () => {
        const { calendarPlayerActions: { setTimerValue }, settings: { time_limit }, setEventSound } = this.props;

        if ( time_limit == 0 ) {
            this.setState( { printTimer: '–' } );
            return undefined;
        } else {

            this.interval = setInterval( () => {

                ( --this.state.sec < 0 ) && ( this.state.sec = this.state.min-- ? 59 : 0 );

                if ( this.state.timerMode === 1 ) {
                    this.state.min = Math.trunc( this.state.min );

                } else {
                    this.state.min = Math.min( this.state.min, 0 ).toFixed();
                }

                if ( this.state.min <= 0 ) {
                    this.state.min = 0;
                }

                this.setState( { printTimer: this.state.min + ':' + this.state.sec } );

                if ( this.state.timerProgress < this.state.timerLimit ) {
                    this.state.timerProgress++;

                    setTimerValue( {
                        timerProgress: this.state.timerProgress,
                        timerLimits: this.state.timerLimit,
                        time: this.state.printTimer,
                        timeOut: false
                    } );
                } else {
                    setTimerValue( {
                        timeOut: true
                    } );
                }
                setEventSound( { events: 'playback' } );
            }, 1000 );
        }
    };

    componentDidMount() {
        this.setTimeLimit();
        this.setTimer();
    };

    componentWillUnmount() {
        clearInterval( this.interval );
    };

    render() {
        return (
            <div className={ styles.wrapper }>
                <span className={ styles.timerText }>{ this.state.printTimer }</span>
            </div>
        );
    };
}

export default Timer;
